module.exports = __webpack_public_path__ + "static/media/wheeled-bg-front-layer-one@2x.d27613e3.png";